import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'COPModeloObraObservacao'

const GetObs = (workId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${workId}`, data, config)
const UpdateObs = (workId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/${workId}`, data, config)

const COPOficialWorkObsRepository = {
  GetObs,
  UpdateObs
}

export default COPOficialWorkObsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/copoficialworkobs.js